var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 5.34506C4.82076 5.34506 4.64156 5.28227 4.50493 5.15696L0.205142 1.2116C-0.0683806 0.960623 -0.0683806 0.553712 0.205142 0.302839C0.478554 0.051967 0.921935 0.051967 1.19548 0.302839L4.99998 3.79391L8.80451 0.302961C9.07803 0.0520889 9.52137 0.0520889 9.79476 0.302961C10.0684 0.553834 10.0684 0.960745 9.79476 1.21172L5.49504 5.15708C5.35834 5.28241 5.17914 5.34506 4.99998 5.34506Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.0fe439bdd6cf442fe37bb3c73c36660b.svg";
export { ForwardRef as ReactComponent };